<template>
    <div>
        <hero-bar :has-right-visible="false" menu-icon="desktop-mac">
            {{ $lang.Menus.NewProject }}
        </hero-bar>

        <!-- The design's liability card: the notice, the acceptance, one action. -->
        <div class="np">
            <div class="np-card">
                <h2 class="np-title">{{ $lang.NewProject.Title }}</h2>

                <div class="np-info">
                    <p>{{ $lang.NewProject.Info_1 }}</p>
                    <p>{{ $lang.NewProject.Info_2 }}</p>
                </div>

                <div class="np-accept">
                    <b-checkbox v-model="isAccepted" :type="hasError_isAccepted ? 'is-danger' : null">
                        {{ $lang.NewProject.Accept }}
                    </b-checkbox>

                    <div v-if="hasError_isAccepted" class="np-error">
                        <span class="mdi mdi-alert-circle-outline" aria-hidden="true"></span>
                        <span>{{ $lang.Menus.EmptyWarning }}</span>
                    </div>

                    <div class="np-actions">
                        <b-button class="np-submit" type="is-primary" @click="openNewProject()">
                            {{ $lang.NewProject.NewProject }}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    import api from '@/api';

    export default {
        name: 'NewProject',
        data() {
            return {
                isActive: true,
                isAccepted: false,
                hasError_isAccepted: false
            }
        },
        mounted() {
            this.$store.state.projectId = '';

            this.$store.state.isFooterFixed = true;
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            openNewProject() {
                this.controlInputs();
                if (this.isAccepted) {
                    var uuid = this.generateUUID();

                    this.resetPreviousDatas();
                    this.$store.state.prevProjectId = -1;
                    this.$store.state.isPrevProject = false;
                    this.$store.state.projectId = uuid + "_Temp";
                    this.$store.state.calcIndex = 1;
                    this.$store.state.circIndex = 1;

                    if (this.$store.state.memberId != 'TestMember') {
                        const currDate = new Date();
                        const log = {
                            MemberId: this.$store.state.memberId,
                            ProjectId: this.$store.state.projectId,
                            IsAccepted: 1,
                            AcceptDate: currDate
                        };
                        api.panels.addNewProjectLog(log).then((res) => {
                            if (res.isError) {
                                console.log("error ");
                            } else {
                                router.push('/projectInfos');
                            }
                        });
                    } else {
                        router.push('/projectInfos');
                    }
                }
            },
            continueProject() {
                this.controlInputs();
                if (this.isAccepted) {
                    this.$store.activeStep = 0;
                    router.push('/projectInfos');
                }
            },

            generateUUID() {
                var d = new Date().getTime(); // Timestamp
                var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16; // random number between 0 and 16
                    if (d > 0) { // Use timestamp until depleted
                        r = (d + r) % 16 | 0;
                        d = Math.floor(d / 16);
                    } else { // Use microseconds since page-load if supported
                        r = (d2 + r) % 16 | 0;
                        d2 = Math.floor(d2 / 16);
                    }
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            },

            resetPreviousDatas() {
                this.$store.activeStep = 0;
                this.$store.canPanelInfosOpen = false;
                this.$store.canEnvConditionsOpen = false;
                this.$store.canCalculationOpen = false;
                this.$store.canResultOpen = false;
                this.$store.canReportPageOpen = false;
                this.$store.canFanCalcOpen = false;

                var payload = { langCode: "", projectName: "", panelName: "", panelNo: "", lastUserName: "", panelManifacturer: "", ratedCurrentIndex: -1, panelRatedCurrent: "", totalEyesNumber: 0, eyesNumber: 0, isCompleted: false };
                this.$store.commit('setProjectInfos', payload);

                var payload2 = { panelType: "", panelTypeIndex: 0, panelDimension: "", panelIP: "", selectedIP_Id: 0, Sair: "", surfaceExplanation: "", virtualSurface: "", virtualSurfaceIndex: 0, virtualSurfaceOption: 0, seperationNumber: 0, ae_value: 0, ae_valueList: [] };
                this.$store.commit('setPanelInfos', payload2);

                var payload3 = { envTemperature: 0, maxTemperature: 0, humidity: "", altitude: 0 };
                this.$store.commit('setEnvConditionDatas', payload3);

                var payload4 = { totalLostPower_1: 0 };
                this.$store.commit('setCalculationDatas', payload4);

                var payload5 = { inPanelTemperature: 0, envMeasureTemperature: 0, totalLostPower_2: 0 };
                this.$store.commit('setCalculationDatas_2', payload5);

                var payload6 = { InputCircuitDef: "", P_InputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_InputCircuits', payload6);

                var payload7 = { OutputCircuitDef: "", P_OutputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_OutputCircuits', payload7);

                var payload8 = { ManuelCircuitDef: "", P_ManuelCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_ManuelCircuits', payload8);

                var payload9 = { P_890: 0, P_Total: 0, result_630A: 0 };
                this.$store.commit('setResultInfos_630A', payload9);

                var payload10 = { value_k: 0, n_value: 0, value_d: 0, value_x: 0, deltaT_0_5: 0, Ab_val: 0, height_val: 0, value_f: 0, value_g: 0, value_c: 0, deltaT_0_75: 0, deltaT_1: 0, result_1600A: 0 };
                this.$store.commit('setResultInfos_1600A', payload10);
            },

            controlInputs() {
                if (this.isAccepted == false) {
                    this.hasError_isAccepted = true;
                } else {
                    this.hasError_isAccepted = false;
                }
            },
        }
    };
</script>

<style lang="scss">
    .np {
        display: flex;
        justify-content: center;
        padding: 40px 26px 56px;
    }

    .np-card {
        display: flex;
        flex-direction: column;
        gap: 18px;
        width: 100%;
        max-width: 660px;
        padding: 28px 30px;
        background: #ffffff;
        border: 1px solid #e3e3e3;
        border-radius: 6px;
    }

    .np-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #1d1d1d;
    }

    .np-info {
        display: flex;
        flex-direction: column;
        gap: 12px;

        p {
            margin: 0;
            font-size: 15px;
            font-weight: 300;
            line-height: 1.65;
            color: #575757;
        }
    }

    .np-accept {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-top: 18px;
        border-top: 1px solid #e3e3e3;

        .b-checkbox.checkbox { align-items: flex-start; font-size: 15px; line-height: 1.5; }
    }

    .np-error {
        display: flex;
        gap: 9px;
        padding: 11px 13px;
        background: #fdecec;
        border-left: 3px solid #c2161c;
        border-radius: 4px;
        font-size: 13px;
        line-height: 1.5;
        color: #9e1216;

        .mdi { flex: none; font-size: 17px; line-height: 1.3; }
    }

    .np-actions {
        display: flex;
        justify-content: flex-end;
        margin-top: 4px;
    }

    .button.np-submit {
        height: 48px;
        padding: 0 26px;
        font-size: 16px;
    }

    @media screen and (max-width: 768px) {
        .np { padding: 24px 16px 40px; }
        .np-card { padding: 20px; }
        .np-actions { justify-content: stretch; }
        .button.np-submit { width: 100%; }
    }
</style>
